import React from 'react';
import PropTypes from 'prop-types';

const GoalInfo = ({ goal, isDefaultGoal }) => (
    <div className="goal-info">
        <div className={isDefaultGoal ? 'default-goal-icon' : 'custom-goal-icon'} />
        <span className="goal">
            {isDefaultGoal ? 'Benchmark Goal' : 'Custom Goal Set'}:&nbsp;<strong>{goal}</strong>
        </span>
    </div>
);

GoalInfo.defaultProps = {
    goal: null,
    isDefaultGoal: false,
};

GoalInfo.propTypes = {
    goal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isDefaultGoal: PropTypes.bool,
};

export default GoalInfo;
